import { useState, useEffect } from 'react'

const TIMER_UPDATE_MS = 500

const useDuration = (localStartTime, gameDurationSeconds, gameSecondsOffset, isRunning = true) => {
  const [duration, setDuration] = useState(null)

  useEffect(() => {
    if (isNaN(gameDurationSeconds) || isNaN(gameSecondsOffset)) {
      return
    }

    const canTick = isRunning && !isNaN(localStartTime)
    const baseDuration = (gameDurationSeconds || 0) + gameSecondsOffset
    const update = () => {
      const localOffset = canTick ? (Date.now() - localStartTime) : 0
      setDuration(baseDuration + localOffset)
    }

    if (!canTick) {
      setDuration(prevDuration => (
        prevDuration === null ? baseDuration : prevDuration
      ))
      return
    }

    update()
    const intervalId = window.setInterval(update, TIMER_UPDATE_MS)

    return () => {
      window.clearInterval(intervalId)
    }
  }, [localStartTime, gameDurationSeconds, gameSecondsOffset, isRunning])

  if (duration === null) {
    return '...'
  }

  const totalSeconds = Math.floor(duration / 1000)
  const seconds = totalSeconds % 60
  const totalMinutes = Math.floor(totalSeconds / 60)
  const minutes = totalMinutes % 60
  const hours = Math.floor(totalMinutes / 60)

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
  }

  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}

export default useDuration
